import React, { useState, useEffect, useRef, useContext } from 'react';
import ExportToPDF, {
  ExportToPDFFnType,
} from '../../../../../../../Components/ExportToPDF/ExportToPDF';
import { IFakturaBildPDF } from '../../../../../../../Components/ExportToPDF/ExportToPDFArgumentTypes';
import { printFakturabild } from '../../../../../Ekonomi/Rutiner/EkonomiskAnalys/Components/VerifikationModal/verifikationUtils';
import { makeStyles } from 'tss-react/mui';
import Dialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import EDOverlay from '../../../../../../../BaseComponents/Overlay/EDOverlay';
import EDFormGroup from '../../../../../../../BaseComponents/FormGroup/EDFormGroup';
import EDFormControlLabel from '../../../../../../../BaseComponents/FormControlLabel/EDFormControlLabel';
import EDSwitch from '../../../../../../../BaseComponents/Switch/EDSwitch';
import {
  IFakturaBilder,
  reduceFakturasidor,
} from '../../../LeverantorFaktura/Queries/Fakturabilder/FakturabilderQuery';
import { BusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import EDAvenyProgress from '../../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import { useAttributeValues } from '../../../../../_Common/Hooks/useAttributeValues';

interface IProps {
  open: boolean;
  onClose: () => void;
  dbName: string;
}

const useStyles = makeStyles()({
  savingOverlay: {
    right: 'calc(50% - 20px)',
    bottom: 'calc(50% - 20px)',
  },
});

const FakturaAttestPrintModal: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { onClose } = props;
  const [loading, setLoading] = useState(false);
  // const [printVerifikation, setPrintVerifikation] = useState(true);
  const [printFakturabilder, setPrintFakturabilder] = useState(true);

  const prevLoading = useRef(loading);

  const dataformContext = useContext(BusinessDataFormContext);

  const { value } = useAttributeValues('Faktura.DefAnkVernr');

  useEffect(() => {
    if (loading === false && prevLoading.current === true) {
      onClose();
    }

    prevLoading.current = loading;
  }, [loading, onClose]);

  const { classes } = useStyles();

  const print = (
    exportFakturaImageToPDF: ExportToPDFFnType<IFakturaBildPDF>,
    dbName: string,
    fakturaBilder: IFakturaBilder | undefined
  ) => {
    if (printFakturabilder) {
      printFakturabild(
        exportFakturaImageToPDF,
        fakturaBilder?.bilder ?? [],
        value ?? '', // vernr
        fakturaBilder?.xml ?? false,
        dbName ?? '',
        '', // bokfdatum
        '', // journalNr
        fakturaBilder?.skannadSvefaktura ?? false,
        setLoading,
        fakturaBilder?.format
      );
    }
    // if (printVerifikation) {
    //   exportVerifikationToPDF(
    //     {
    //       reportName: 'Verifikation',
    //       dbname: dbName,
    //       verifikationsInfo: verifikation,
    //       fileName: 'verifikation_' + verifikationsNr,
    //     },
    //     setLoading
    //   );
    // }
  };

  return (
    <ExportToPDF<IFakturaBildPDF>>
      {exportFakturaBildToPDF => (
        <Dialog
          open={props.open}
          onClose={props.onClose}
          title="Skriv ut"
          footerActions={[
            {
              label: 'Avbryt',
              onClick: props.onClose,
            },
            {
              label: loading ? 'Skriver ut' : 'Skriv ut',
              buttonProps: {
                disabled: loading,
              },
              onClick: () => {
                print(
                  exportFakturaBildToPDF,
                  // exportVerifikationToPDF,
                  props.dbName,
                  reduceFakturasidor(
                    dataformContext?.data?._Associations?.Faktura
                  )
                );
              },
            },
          ]}
        >
          <EDOverlay
            overlay={loading && <EDAvenyProgress />}
            classes={{ overlay: classes.savingOverlay }}
          >
            <EDFormGroup>
              <>
                <EDFormControlLabel
                  control={
                    <EDSwitch
                      checked={printFakturabilder}
                      onChange={(_, checked) => setPrintFakturabilder(checked)}
                    />
                  }
                  label="Skriv ut fakturabild"
                />
                {/* <EDFormControlLabel
                  control={
                    <EDSwitch
                      disabled={true}
                      checked={false}
                      onChange={() => {}}
                    />
                  }
                  label="Skriv ut verifikation"
                />
                <EDFormControlLabel
                  control={
                    <EDSwitch
                      disabled={true}
                      checked={false}
                      onChange={() => {}}
                    />
                  }
                  label="Skriv ut dokument"
                /> */}
              </>
            </EDFormGroup>
          </EDOverlay>
        </Dialog>
      )}
    </ExportToPDF>
  );
};

export default FakturaAttestPrintModal;
